import { MutationTree } from 'vuex';
import { IFundSearchState } from './types';

const mutations: MutationTree<IFundSearchState> = {
  reset(state) {
    state.results = [];
    state.lookup = '';
  },

  lookup(state, lookup) {
    state.lookup = lookup;
  },

  setBusinessCode(state, businessCode) {
    state.businessCode = businessCode;
  },

  setNumberOfFetching(state, numberOfFetching) {
    state.numberOfFetching = numberOfFetching;
  },

  results(state, results) {
    state.results = results;
  },

  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
  },

  setFundSearchApiEndpoint(state, fundSearchApiEndpoint) {
    state.fundSearchApiEndpoint = fundSearchApiEndpoint;
  },

  setSelectedResultIndex(state, newIndex) {
    state.selectedResultIndex = newIndex;
  },

  setCacheSuffix(state, cacheSuffix) {
    state.cacheSuffix = cacheSuffix;
  },

  setLastFetchError(state, lastFetchError) {
    state.lastFetchError = lastFetchError;
  },
};

export default mutations;
